// extracted by mini-css-extract-plugin
export var loadingSpinner = "_u-0";